import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  scale020,
  scale080,
  scale100,
  scale140,
  scale150,
  scale200,
  spaceXL,
  spaceXXL,
  space3XL,
  xdlColorHoverSecondary,
} from '@xing-com/tokens';
import { Headline, BodyCopy } from '@xing-com/typography';

export const Container = styled.section`
  margin-bottom: calc(${scale020} + ${scale200});
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceXXL};

  @media ${mediaConfined} {
    margin-bottom: ${space3XL};
  }
`;

export const Text = styled(BodyCopy)`
  margin-bottom: calc(${scale020} + ${scale140});

  & > a {
    &:hover,
    &:active,
    &:visited {
      text-decoration: none;
    }
  }

  @media ${mediaConfined} {
    margin-bottom: ${space3XL};
  }
`;

export const CardContainer = styled.div`
  background-color: ${xdlColorHoverSecondary};
  margin: 0 -${scale100} calc(${scale020} + ${scale200});
  padding: ${scale150};

  @media ${mediaConfined} {
    border-radius: ${scale080};
    margin: 0 0 calc(${scale020} + ${scale200});
    padding: ${spaceXL};

    & > div {
      &:first-child {
        border-radius: ${scale080} ${scale080} 0 0;
      }
      &:not(:first-child):not(:last-child) {
        border-radius: 0;
      }
      &:last-child {
        border-radius: 0 0 ${scale080} ${scale080};
      }
    }
  }
`;
